import { createContext } from '@weavix/mobx';
import { PubSubService } from 'weavix-shared/services/pub-sub.service';

export interface Environment {
    pubSubService: PubSubService;
}

export const environmentContext = createContext<Environment>();
